// Order Status enum matching backend
export enum OrderStatus {
  DRAFT = 'Draft',
  PENDING = 'Pending',
  CANCELLED = 'Cancelled',
  DECLINED = 'Declined',
  REFUNDED = 'Refunded',
  APPROVED = 'Approved',
  CHANGING = 'Changing',
  IN_PROGRESS = 'In-progress',
  DELIVERY = 'Delivery',
  COMPLETED = 'Completed'
}

// Package selection for order details
export interface OrderPackageSelection {
  packageId: string;
  productId: string;
  type: 'one-select' | 'multi-select' | 'addons';
  title: string;
  subTitle?: string;
  selectedOptions?: string[];
  selectedItems?: Array<{
    itemId: string;
    units: number;
  }>;
}

// Contact details snapshot at checkout
export interface OrderContactDetails {
  contactName?: string;
  phoneNumber?: string;
  email?: string;
}

// Event details snapshot at checkout
export interface OrderEventDetails {
  eventName?: string;
  eventDate?: string;
  eventAddress?: string;
  eventZone?: string;
  eventBuildingNumber?: string;
  eventStreetNumber?: string;
}

// Admin Order List Item (used by list page and as base for detail)
export interface AdminOrderListItem {
  orderId: string;
  orderNumber: string;
  createdAt: number;
  updatedAt: number;
  vendor: {
    vendorId: string;
    name: string;
    category?: string;
  };
  customer: {
    userId: string;
    name: string;
    phone: string;
  };
  event?: {
    eventId?: string;
    dateTime?: string;
    address?: string;
  };
  product: {
    productId: string;
    name: string;
    details: string;
  };
  specialRequests?: string;
  total: number;
  status: OrderStatus;
  hasDispute: boolean;
  hasRefund: boolean;
  // Fields available on detail response (from full OrderRecord spread)
  amount?: number;
  discountAmount?: number;
  discountType?: string;
  shippingFee?: number;
  packages?: OrderPackageSelection[];
  contactDetails?: OrderContactDetails;
  eventDetails?: OrderEventDetails;
  disputeReason?: string;
  disputeDate?: number;
  cartId?: string;
  eventId?: string;
  startDateTime?: string;
  vendorId?: string;
  userId?: string;
  productId?: string;
}

// Orders Query Parameters
export interface OrdersQueryParams {
  limit?: number;
  afterCursor?: string;
  status?: OrderStatus;
  vendorId?: string;
  userId?: string;
  search?: string;
  section?: 'all' | 'disputed' | 'refunds';
}

// Orders Response
export interface AdminOrdersResponse {
  success: boolean;
  orders: AdminOrderListItem[];
  pagination: {
    endCursor?: string;
    hasMore: boolean;
    total?: number;
  };
}

// Vendor/User List Item
export interface VendorListItem {
  vendorId: string;
  name: string;
}

export interface UserListItem {
  userId: string;
  name: string;
}

// Update Status Request
export interface UpdateOrderStatusRequest {
  status: OrderStatus;
}

// Update Status Response
export interface UpdateOrderStatusResponse {
  success: boolean;
  order: any; // Full order record
}

// API Response Types
export interface GetAllOrdersResponse extends AdminOrdersResponse {}

export interface GetOrderDetailsResponse {
  success: boolean;
  data: AdminOrderListItem;
  timestamp: number;
}

export interface GetVendorsWithOrdersResponse {
  success: boolean;
  vendors: VendorWithOrders[];
}

export interface GetUsersWithOrdersResponse {
  success: boolean;
  users: UserWithOrders[];
}

// Vendor and User with Orders
export type VendorWithOrders = VendorListItem;
export type UserWithOrders = UserListItem;
